/** 
 * @Author: Zero
 * @Date: 2023-03-27 18:57:07
 * @Explain: Home
 */

import { getLocalStorage, setLocalStorage, jsonParse, removeLocalStorage } from '@/utils/global';
import { StoreKeyEnum } from '@/definition/common/data.d';

interface toDoStatusInfoTypes {
  /** key = 业务ID + 用户ID */
  [key: string]: {
    /** 存储信息时间 */
    storageTime: string,
    /** 当前todo展开状态 */
    isNowStatus?: boolean,
  }
}

export interface HomeState {
  /** todolist 各业务、用户下状态存储 */
  toDoStatusInfo: toDoStatusInfoTypes;
}

export type ModelType = {
  namespace: string;
  state: HomeState;
  reducers: {
    setToDoStatusInfo: (state: HomeState, action: { payload: any }) => any;
    resetToDoStatusInfo: (state: HomeState, action: { payload: any }) => any;
  };
};

const HomeModel: ModelType = {
  namespace: 'HomeModel',
  state: {
    // Home - todolist用户状态相关信息
    toDoStatusInfo: jsonParse(getLocalStorage(StoreKeyEnum.HOME_TODOLIST_STATUS_INFO)) || {},
  },
  reducers: {
    // 设置 todolist用户状态相关信息
    setToDoStatusInfo(state, action) {
      setLocalStorage(StoreKeyEnum.HOME_TODOLIST_STATUS_INFO, action.payload);
      return {
        ...state,
        toDoStatusInfo: action.payload || [],
      };
    },
    // 重置 todolist用户状态相关信息
    resetToDoStatusInfo(state, action) {
      removeLocalStorage(StoreKeyEnum.HOME_TODOLIST_STATUS_INFO)
      return {
        ...state,
        toDoStatusInfo: {},
      };
    },
  },
};

export default HomeModel;